module.exports = __webpack_public_path__ + "img/pittsburgh2.73883a3e.jpg";